import { ICoreContext } from '@msdyn365-commerce/core';
import { AsyncResult } from '@msdyn365-commerce/retail-proxy';
import { IGetDirectLineTokenData } from '../../actions/get-direct-line-token.action';
import { IUserRoleState } from '../../states/user-role-state';
import { ILxsServiceAgentProps, ILxsServiceAgentResources } from './lxs-service-agent.props.autogenerated';

export const INCOMING_ACTIVITY = 'DIRECT_LINE/INCOMING_ACTIVITY';
export const OUTGOING_ACTIVITY = 'DIRECT_LINE/POST_ACTIVITY';
export const HTTPS = 'https://';

export const SET_CONTEXT_EVENT = 'pvaSetContext';
export const START_CONVERSATION_EVENT = 'startConversationPortal';
export const START_CONVERSATION_RESET_EVENT = 'StartConversationPortalAfterReset';
export const CONVERSATION_TYPE_EVENT = 'event';
export const CONVERSATION_TYPE_MESSAGE = 'message';

export const CONVERSATION_NAME_DOCUMENT = 'downloadDocument';
export const CONVERSATION_ROLE_BOT = 'bot';
export const CONVERSATION_TYPE_TRACE = 'trace';
export const STORAGE_KEY = 'webchatConversation';
export const MAX_TRANSCRIPT_COUNT = 200;

// Uninitialized = 0, Connecting = 1, Connected = 2, ExpiredToken = 3, FailedToConnect = 4, Ended = 5
export const CONNECTION_STATUS_CONNECTED = 2;
export const CONNECTION_STATUS_EXPIRED_TOKEN = 3;
export const CONNECTION_STATUS_FAILED_TO_CONNECT = 4;

export const DIRECT_LINE_GLOBAL_DOMAIN = 'https://directline.botframework.com/v3/directline';
export const DIRECT_LINE_EUROPE_DOMAIN = 'https://europe.directline.botframework.com/v3/directline';

export const DIRECT_LINE_CONNECTION_RESOURCE_NOT_FOUND = 'ResourceNotFound';
export const DIRECT_LINE_CONNECTION_REGION_NOT_ALLOWED = 'RegionNotAllowed';
export const DIRECT_LINE_CONNECTION_REGION_MISMATCH = 'region_mismatch';
export const DIRECT_LINE_CONNECTION_TOKEN_ERROR = 'token_error';
export const DIRECT_LINE_CONNECTION_OK = 'ok';
export const DIRECT_LINE_CONNECTION_UNKNOWN = 'unknown';

export type RegionalProbeResult = 'ok' | 'region_mismatch' | 'token_error' | 'unknown';

export interface ILxsServiceAgentData {
    getDirectLineToken: AsyncResult<IGetDirectLineTokenData>;
    userRoleState: AsyncResult<IUserRoleState>;
}

export interface InitWebChatParams {
    directLineToken: string;
    directLineDomain: string;
    savedConversation: IStoredConversation | null;
    userToken: string;
    context: ICoreContext;
    resources: ILxsServiceAgentResources;
    userName: string | undefined;
    locale: string;
    canonicalDomain: string;
    container: HTMLDivElement;
    isReset: boolean;
    writeStoredConversation: (conversation: IStoredConversation) => void;
    onRegionalConnectionFailure?: () => Promise<void> | void;
    onExpiredToken?: () => Promise<void> | void;
}

export interface ILxsServiceAgentViewProps extends ILxsServiceAgentProps<ILxsServiceAgentData> {
    validateRegionalTokenError: (tokenToValidate: string) => Promise<boolean>;
    probeRegionalDirectLine: (tokenToValidate: string) => Promise<RegionalProbeResult>;
    fetchDirectLineToken: (context: ICoreContext) => Promise<string | null>;
    readStoredConversation: () => IStoredConversation | null;
    writeStoredConversation: (conversation: IStoredConversation) => void;
    clearStoredConversation: () => void;
    getValidStoredConversation: (directLineToken: string, userToken: string) => IStoredConversation | null;
    CLASS_NAME: string;
}

export interface IStoredConversation {
    conversationId: string;
    directLineToken: string;
    userToken: string;
    transcript: any[];
}

declare global {
    interface Window {
        WebChat?: any;
    }
}
